import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { placeEventBet, cancelEventBet } from '../../services/api';
import pointsIcon from '../../assets/points_icon.png';

export default function EventRow({ event, isMatchLocked, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [amount, setAmount] = useState('10');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const userBet = event.bets && event.bets[0];
  const isThreeWay = !!event.option3;
  const isLocked = event.isLocked || event.winner !== null || isMatchLocked;

  const openBetModal = (choice) => {
    if (isLocked) return;
    if (userBet && userBet.choice !== choice) return;

    setSelectedChoice(choice);
    setAmount('10'); // Сбрасываем на дефолтную сумму добавления
    setShowModal(true);
    setMessage('');
  };

  const handlePlaceBet = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await placeEventBet({
        eventId: event.id,
        choice: selectedChoice,
        amount: parseInt(amount, 10)
      });
      setMessage('Ставка принята!');
      setTimeout(() => {
        setShowModal(false);
        onRefresh();
      }, 1000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelBet = async () => {
    if (!window.confirm('Отменить ставку на это событие?')) return;
    setLoading(true);
    try {
      await cancelEventBet(event.id);
      setMessage('Отменено!');
      setTimeout(() => {
        setShowModal(false);
        onRefresh();
      }, 1000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Ошибка отмены');
    } finally {
      setLoading(false);
    }
  };

  const renderButton = (choice, optionName, odds) => {
    if (!optionName) return null;
    const isChosen = userBet && userBet.choice === choice;
    const isDisabled = isLocked || (userBet && userBet.choice !== choice);

    // Подсветка победы/поражения ставки пользователя
    let resultClass = '';
    if (event.winner) {
      if (isChosen) {
        resultClass = event.winner === choice ? 'won' : 'lost';
      }
    }

    return (
      <button
        key={choice}
        type="button"
        className={`event-btn-tile ${isChosen ? 'active' : ''} ${isDisabled ? 'disabled' : ''} ${resultClass}`}
        onClick={() => openBetModal(choice)}
        disabled={isDisabled}
      >
        <span className="event-opt-title">{optionName}</span>
        <span className="event-opt-odds">
          {isChosen ? (
            <span className="event-bet-val">
              {userBet.amount} <img src={pointsIcon} alt="pts" className="points-icon-small" />
            </span>
          ) : (
            odds ? odds.toFixed(2) : '-'
          )}
        </span>
      </button>
    );
  };

  let selectedOdds = 0;
  let selectedName = '';
  if (selectedChoice === 1) { selectedName = event.option1; selectedOdds = event.odds1; }
  else if (selectedChoice === 2) { selectedName = event.option2; selectedOdds = event.odds2; }
  else if (selectedChoice === 3) { selectedName = event.option3; selectedOdds = event.odds3; }

  const currentBetAmount = userBet ? userBet.amount : 0;
  const addedAmount = parseInt(amount, 10) || 0;
  const totalBetAmount = currentBetAmount + addedAmount;
  const potentialWin = Math.floor(totalBetAmount * (selectedOdds || 1));
  const profit = potentialWin - totalBetAmount;

  return (
    <div className="event-card-item">
      <div className="event-card-title">
        {event.isLocked && !event.winner && <span className="event-lock">🔒 </span>}
        {event.name}
      </div>

      <div className={`event-buttons-grid ${isThreeWay ? 'three-way' : ''}`}>
        {renderButton(1, event.option1, event.odds1)}
        {renderButton(2, event.option2, event.odds2)}
        {isThreeWay && renderButton(3, event.option3, event.odds3)}
      </div>

      {/* Всплывающее окно ставки через React Portal */}
      {showModal && createPortal(
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content modal-size-narrow" onClick={e => e.stopPropagation()}>
            <button className="modal-close-button" onClick={() => setShowModal(false)}>✕</button>

            <div className="bet-modal-header">
              <h3>{userBet ? 'Добавить к ставке' : event.name}</h3>
            </div>

            <div className="bet-pick-highlight">
              <span>Исход: <strong>{selectedName}</strong></span>
              <span className="odds-badge">x{selectedOdds ? selectedOdds.toFixed(2) : '-'}</span>
            </div>

            {userBet && (
              <div className="already-bet-alert">
                <span>Уже в игре: <strong>{userBet.amount}</strong></span>
                <img src={pointsIcon} alt="pts" className="points-icon-small" />
              </div>
            )}

            <form onSubmit={handlePlaceBet} className="transfer-form">
              <label>{userBet ? 'Сколько добавить:' : 'Сумма ставки:'}</label>
              <div className="amount-input-wrapper">
                <input
                  type="number"
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                  min="1"
                  required
                  autoFocus
                />
                <img src={pointsIcon} alt="points" className="points-icon" />
              </div>

              <div className="bet-calc-preview">
                {userBet && (
                  <div style={{ marginBottom: 6 }}>
                    <span className="calc-label">Итоговая ставка:</span>
                    <span className="calc-val">{totalBetAmount} pts</span>
                  </div>
                )}
                <div>
                  <span className="calc-label">Возможный выигрыш:</span>
                  <span className="calc-val">{potentialWin} pts</span>
                </div>
                <div>
                  <span className="calc-label">Чистая прибыль:</span>
                  <span className="calc-val profit">+{profit > 0 ? profit : 0} pts</span>
                </div>
              </div>

              {message && <p className="form-message">{message}</p>}

              <div className="modal-actions-row">
                {userBet && (
                  <button type="button" className="sheet-btn cancel" onClick={handleCancelBet} disabled={loading}>
                    Отменить
                  </button>
                )}
                <button type="submit" className="sheet-btn submit" disabled={loading}>
                  {loading ? '...' : (userBet ? 'Добавить' : 'Поставить')}
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}